import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { UseFormPayload } from '@domain-group/react-hooks'

import {
  Box, Button, Form, SectionDivider, SidebarModalListItem,
} from '@domain-group/suit-theme'

import { PortalOptionModel } from '@models/types'

import { GetElementType } from '@redux/modules/types'

type NodePropertiesArray = Required<PortalOptionModel>['node_properties']

interface NodePropertiesProps {
  callbacks: {
    toggleNodeProperty: (nodeProperty: GetElementType<NodePropertiesArray>) => void,
  },
  nodeProperties: NodePropertiesArray,
  nodePropertyFormPayload: UseFormPayload,
}

const NodeProperties = (props: NodePropertiesProps) => {
  const { callbacks: { toggleNodeProperty }, nodeProperties, nodePropertyFormPayload } = props

  const {
    entityState,
    entityState: {
      name,
      value,
    },
    handlers,
    saveEnabled,
  } = nodePropertyFormPayload

  return (
    <Box flexDirection="column" marginTop="large">
      <SectionDivider>ADD NODE ATTRIBUTE</SectionDivider>

      <Form.Field label="Attribute Name" marginTop="large">
        <input name="name" type="text" value={name} {...handlers} />
      </Form.Field>

      <Form.Field label="Attribute Value" marginTop="large">
        <input name="value" type="text" value={value} {...handlers} />
      </Form.Field>

      <Button
        buttonStyle="secondaryEdit"
        disabled={!saveEnabled}
        icon={<FontAwesomeIcon icon={faPlus} />}
        marginTop="large"
        onClick={() => toggleNodeProperty(entityState)}
        size="medium"
      >
        Add Attribute
      </Button>

      {!!nodeProperties.length && (
        <>
          <SectionDivider boxProps={{ marginTop: 'large' }}>NODE ATTRIBUTES</SectionDivider>

          {nodeProperties.map(nodeProperty => (
            <SidebarModalListItem title={nodeProperty.name}>
              {/*
               // @ts-expect-error TS2339 */}
              <SidebarModalListItem.TertiaryText>{nodeProperty.value}</SidebarModalListItem.TertiaryText>

              {/*
               // @ts-expect-error TS2339 */}
              <SidebarModalListItem.Actions>
                {/*
                 // @ts-expect-error TS2339 */}
                <SidebarModalListItem.Icon
                  onClick={() => toggleNodeProperty(nodeProperty)}
                  type="delete"
                />
                {/*
               // @ts-expect-error TS2339 */}
              </SidebarModalListItem.Actions>
            </SidebarModalListItem>
          ))}
        </>
      )}
    </Box>
  )
}

export default NodeProperties
